import styled from 'styled-components';
import breakpoints from '../breakpoints';

const Button = styled.button`
  border: 1px solid #006aff;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  height: 54px;
  letter-spacing: 0;
  line-height: 21px;
  text-align: center;
  padding: 8px 16px;
`;

const Hero = styled(Button)`
  background-color: #006aff;
  color: #ffffff;
`;

const Transparent = styled(Button)`
  background-color: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
`;

const Primary = styled(Button)`
  background-color: #006aff;
  color: #ffffff;
  width: 184px;
`;

const Secondary = styled(Button)`
  background-color: #ffffff;
  color: #006aff;
  width: 184px;
`;

const Cta = styled(Button)`
  background-color: #006aff;
  color: #ffffff;
  height: 42px;
  width: 100%;

  @media ${breakpoints.medium} {
    width: 155px;
  }
`;

export const Image = styled.img`
  height: 14px;
  margin-right: 16px;
  width: 14px;
`;

export default {
  Hero,
  Transparent,
  Primary,
  Secondary,
  Cta,
  Image,
};
